var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 440,
    height: 291,
    viewBox: "0 0 440 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19657",
    "data-name": "Rectangle 19657",
    width: 440,
    height: 291,
    transform: "translate(1035 317)",
    opacity: 0.452
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18738",
    "data-name": "Rectangle 18738",
    width: 471.479,
    height: 289.099,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_160",
    "data-name": "Mask Group 160",
    transform: "translate(-1035 -317)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44520",
    "data-name": "Group 44520",
    transform: "translate(1035.484 318.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44619",
    "data-name": "Group 44619",
    transform: "translate(0 -0.002)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139245",
    "data-name": "Path 139245",
    d: "M419.134,885.068a30.738,30.738,0,1,0,30.738,30.738,30.737,30.737,0,0,0-30.738-30.738m-5.675-31.176h11.369l2.286,11.889a50.3,50.3,0,0,1,10.091,2.7l7.928-9.157L454.98,865l-3.87,11.52a50.99,50.99,0,0,1,7.333,7.34l11.433-3.962,5.685,9.846-9.086,8.019a50.329,50.329,0,0,1,2.679,10.035l11.894,2.287v11.369l-11.9,2.406a50.342,50.342,0,0,1-2.689,10.032l9.137,7.911-5.684,9.846-11.5-3.864a50.9,50.9,0,0,1-7.354,7.343l3.957,11.418-9.846,5.685-8.013-9.079a50.339,50.339,0,0,1-10.041,2.677l-2.286,11.889H413.459l-2.407-11.906a50.236,50.236,0,0,1-9.959-2.667l-8.027,9.1-9.846-5.684,3.966-11.447a51,51,0,0,1-7.332-7.325l-11.532,3.874-5.685-9.846,9.166-7.936a50.3,50.3,0,0,1-2.683-10.016l-11.9-2.406V910.087l11.894-2.287a50.306,50.306,0,0,1,2.673-10.019l-9.114-8.043,5.685-9.846,11.466,3.973a50.9,50.9,0,0,1,7.311-7.322L383.255,865l9.846-5.684,7.942,9.174a50.325,50.325,0,0,1,10.009-2.686Z",
    transform: "translate(-304.062 -726.821)",
    fill: "#bed7e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139246",
    "data-name": "Path 139246",
    d: "M1084.323,592.86a19.713,19.713,0,1,0,19.713,19.713,19.713,19.713,0,0,0-19.713-19.713m-3.64-19.994h7.291l1.466,7.625a32.237,32.237,0,0,1,6.472,1.729l5.084-5.872,6.314,3.645-2.482,7.387a32.713,32.713,0,0,1,4.7,4.707l7.332-2.541,3.646,6.314L1114.683,601a32.294,32.294,0,0,1,1.718,6.435l7.628,1.467V616.2l-7.633,1.543a32.268,32.268,0,0,1-1.725,6.434l5.86,5.074-3.645,6.314-7.375-2.478a32.667,32.667,0,0,1-4.717,4.709l2.538,7.323-6.315,3.645-5.138-5.822a32.31,32.31,0,0,1-6.44,1.716l-1.466,7.625h-7.291l-1.544-7.636a32.231,32.231,0,0,1-6.387-1.71l-5.148,5.833-6.314-3.646,2.544-7.341a32.7,32.7,0,0,1-4.7-4.7l-7.4,2.484-3.646-6.314,5.878-5.09a32.263,32.263,0,0,1-1.721-6.423l-7.633-1.543v-7.291l7.628-1.467a32.255,32.255,0,0,1,1.714-6.425l-5.845-5.158,3.646-6.314,7.353,2.548a32.643,32.643,0,0,1,4.689-4.7l-2.489-7.406,6.314-3.646,5.094,5.883a32.3,32.3,0,0,1,6.419-1.722Z",
    transform: "translate(-889.163 -487.616)",
    fill: "#bed7e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139247",
    "data-name": "Path 139247",
    d: "M2040.852,885.068a30.738,30.738,0,1,0,30.738,30.738,30.737,30.737,0,0,0-30.738-30.738m-5.675-31.176h11.369l2.287,11.889a50.3,50.3,0,0,1,10.091,2.7l7.929-9.157L2076.7,865l-3.87,11.52a50.968,50.968,0,0,1,7.333,7.34l11.433-3.962,5.685,9.846-9.086,8.019a50.331,50.331,0,0,1,2.679,10.035l11.894,2.287v11.369l-11.9,2.406a50.317,50.317,0,0,1-2.689,10.032l9.137,7.911-5.684,9.846-11.5-3.864a50.91,50.91,0,0,1-7.354,7.343l3.958,11.418-9.846,5.685-8.013-9.079a50.323,50.323,0,0,1-10.041,2.677l-2.287,11.889h-11.369l-2.407-11.906a50.241,50.241,0,0,1-9.959-2.667l-8.027,9.1-9.845-5.684,3.967-11.447a50.977,50.977,0,0,1-7.332-7.325l-11.532,3.874-5.685-9.846,9.167-7.936a50.268,50.268,0,0,1-2.683-10.016l-11.9-2.406V910.087l11.894-2.287a50.3,50.3,0,0,1,2.673-10.019l-9.114-8.043,5.684-9.846,11.466,3.973a50.918,50.918,0,0,1,7.311-7.322L2004.972,865l9.846-5.684,7.942,9.174a50.336,50.336,0,0,1,10.009-2.686Z",
    transform: "translate(-1684.446 -726.821)",
    fill: "#bed7e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139248",
    "data-name": "Path 139248",
    d: "M1912.139,582.976l30.247,5.965,33.114-53.993,8.1,4.548-18.794,54.64c-3.213,9.839-10,18.868-19.768,19.92l-38.6-6.056a54.323,54.323,0,0,1,5.7-25.023",
    transform: "translate(-1622.736 -455.34)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139249",
    "data-name": "Path 139249",
    d: "M2350.438,362.82c4.483-9,9.709-17.467,14.795-26.143l4.743-8.426c1-2.207,3.478-1.307,2.681,1.285l-3.587,11.007,1.878,3.406,4.637,3.173c1.442,1.461.957,2.924-.607,4.39a3.9,3.9,0,0,1-2.742,3.78,4.222,4.222,0,0,1-2.859,3.679l-3.393-1.985c-1.3,2.09-2.445,4.174-4.457,5.511-.267,1.981-1.442,3.377-1.838,5.343Z",
    transform: "translate(-2000.662 -278.34)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139250",
    "data-name": "Path 139250",
    d: "M1506.68,833.833l-15.231-46.915c-2.918-19.455,4.848-33.689,22.8-35.2l24.242-1.651c17.484,0,24.629,4.456,27.971,17.459l27.185,129.23h-86.689Z",
    transform: "translate(-1268.992 -638.447)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139251",
    "data-name": "Path 139251",
    d: "M1584.829,367.108c-2.714-4.334-6.143-8.451-8.787-12.5l-9.971-24.128,5.424-5.882c-17.014-29.357-59.391-8.463-49.812,21.69a35.929,35.929,0,0,1,.391,20.907l28.908-.039.03-1.135,1.2,1.134Z",
    transform: "translate(-1294.051 -264.266)",
    fill: "#0a213d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139252",
    "data-name": "Path 139252",
    d: "M1618.722,459.508l.761-10.191c8.1-.143,13.575-3.407,14.668-11.866-.578-11.738-1.615-22.978-4.654-32.058-29.484-.29-23.808,25.246-28.943,16.049-9.08-9.326-20.365,6.089-3.176,11.887l4.256,25.92c2.984,3.237,13.378,1.834,17.089.26",
    transform: "translate(-1352.055 -345.063)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139253",
    "data-name": "Path 139253",
    d: "M1443.118,277.3a14.919,14.919,0,1,1-14.9,14.939,14.919,14.919,0,0,1,14.9-14.939",
    transform: "translate(-1215.681 -236.038)",
    fill: "#0a213d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139254",
    "data-name": "Path 139254",
    d: "M1728.927,692.763l-11.915-1.365,11.534,6.461Z",
    transform: "translate(-1461.498 -588.508)",
    fill: "#00123b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139255",
    "data-name": "Path 139255",
    d: "M1817.082,537.807a.415.415,0,0,0-.71.432l5.357,8.8.015.024h0c.144.2.215.344.206.415,0,.006-.02,0-.062.006h0l-2.069.182a.416.416,0,0,0,.074.829l2.069-.182h0a.362.362,0,0,0,.056-.009.849.849,0,0,0,.755-.718,1.472,1.472,0,0,0-.346-1Z",
    transform: "translate(-1546.021 -457.604)",
    fill: "#302b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139256",
    "data-name": "Path 139256",
    d: "M1797.6,631.5a.415.415,0,1,0-.581.594,6.651,6.651,0,0,0,3.461,1.9,6.932,6.932,0,0,0,4.04-.575.416.416,0,0,0-.329-.765,6.141,6.141,0,0,1-3.563.524,5.846,5.846,0,0,1-3.028-1.674",
    transform: "translate(-1529.497 -537.423)",
    fill: "#302b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139257",
    "data-name": "Path 139257",
    d: "M1848.094,486.78a.416.416,0,1,0,.233.8c.011,0,3.76-1.175,6.13-.381a.415.415,0,0,0,.264-.787c-2.633-.882-6.616.366-6.626.369",
    transform: "translate(-1572.819 -413.758)",
    fill: "#302b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139258",
    "data-name": "Path 139258",
    d: "M1874.424,532.911a1.271,1.271,0,1,1-1.155,1.378,1.27,1.27,0,0,1,1.155-1.378",
    transform: "translate(-1594.498 -453.603)",
    fill: "#302b36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139259",
    "data-name": "Path 139259",
    d: "M1746.188,495.765a.416.416,0,1,0,.234.8c.01,0,3.76-1.175,6.13-.382a.415.415,0,1,0,.263-.787c-2.632-.881-6.616.367-6.627.37",
    transform: "translate(-1486.077 -421.405)",
    fill: "#302b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139260",
    "data-name": "Path 139260",
    d: "M1772.524,541.9a1.271,1.271,0,1,1-1.155,1.378,1.272,1.272,0,0,1,1.155-1.378",
    transform: "translate(-1507.762 -461.252)",
    fill: "#302b36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139261",
    "data-name": "Path 139261",
    d: "M2254.783,1187.737c13.743-13.6,21.894-8.245,26.7,8.434l-26.554.442Z",
    transform: "translate(-1919.242 -1004.419)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139262",
    "data-name": "Path 139262",
    d: "M1621.412,1026.754l10.091,29.131,63.323,1.392,5.752,3.88-5.6,5.41-56.666,11.3c-10.117,2.183-21.337.871-27.168-7.036l-14.219-36.388a54.312,54.312,0,0,1,24.484-7.691",
    transform: "translate(-1359.284 -873.959)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139263",
    "data-name": "Path 139263",
    d: "M2091.3,1291.707h55.023a1.584,1.584,0,0,0,0-3.167H2091.3a1.584,1.584,0,1,0,0,3.167",
    transform: "translate(-1778.743 -1096.788)",
    fill: "#00302e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139264",
    "data-name": "Path 139264",
    d: "M2345.857,967.773h70.627a2.2,2.2,0,0,1,2.185,2.883l-11.17,46.157a3.914,3.914,0,0,1-3.581,2.883h-70.627a2.2,2.2,0,0,1-2.185-2.883l11.17-46.157a3.914,3.914,0,0,1,3.58-2.883",
    transform: "translate(-1984.137 -823.755)",
    fill: "#00302e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139265",
    "data-name": "Path 139265",
    d: "M2357.16,967.773h70.627a2.2,2.2,0,0,1,2.185,2.883l-11.169,46.157a3.915,3.915,0,0,1-3.58,2.883H2344.6a2.2,2.2,0,0,1-2.185-2.883l11.17-46.157a3.914,3.914,0,0,1,3.58-2.883",
    transform: "translate(-1993.759 -823.755)",
    fill: "#384f52",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139266",
    "data-name": "Path 139266",
    d: "M2091.3,1298.567h55.023a1.588,1.588,0,0,0,1.583-1.584h0a1.587,1.587,0,0,0-1.583-1.583H2091.3a1.588,1.588,0,0,0-1.584,1.583h0a1.588,1.588,0,0,0,1.584,1.584",
    transform: "translate(-1778.743 -1102.627)",
    fill: "#384f52",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139267",
    "data-name": "Path 139267",
    d: "M2612.185,1105.361l8.438-7.049,5.661,7.049-8.438,7.049Z",
    transform: "translate(-2223.457 -934.868)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139268",
    "data-name": "Path 139268",
    d: "M2547.272,311.285H2558.3c2.176,0,1.989,10.131,0,10.131h-11.027c-1.989,0-2.176-10.131,0-10.131",
    transform: "translate(-2166.875 -264.961)",
    fill: "#61738c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139269",
    "data-name": "Path 139269",
    d: "M2573.811,379.366a2.967,2.967,0,0,1-2.366,1.183h-3.509a2.966,2.966,0,0,1-2.366-1.183Z",
    transform: "translate(-2183.78 -322.911)",
    fill: "#3d3638",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139270",
    "data-name": "Path 139270",
    d: "M2479.319.021c-17.659-.84-27.91,20.974-12.087,35.182,2.429,2.548,6.13,7.195,6.573,11.118h11.027c.443-3.923,4.144-8.57,6.573-11.118,15.823-14.208,5.573-36.022-12.087-35.182",
    transform: "translate(-2093.408 0.002)",
    fill: "#f2a105",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139271",
    "data-name": "Path 139271",
    d: "M2535.147,127.493c-.386-1.921-.942-3.274-1.731-3.609a1.728,1.728,0,0,0-1.812.2,1.249,1.249,0,0,0-.462.909,1.538,1.538,0,0,0,.535,1.143,6.284,6.284,0,0,0,3.471,1.357m11.211-3.609c-.789.336-1.344,1.688-1.731,3.609a6.279,6.279,0,0,0,3.471-1.357,1.538,1.538,0,0,0,.535-1.143,1.247,1.247,0,0,0-.462-.909,1.728,1.728,0,0,0-1.812-.2m-10.675,25.855c0-.053.856-14.29-.422-21.645a7.06,7.06,0,0,1-3.992-1.538,2.1,2.1,0,0,1-.711-1.581,1.829,1.829,0,0,1,.67-1.338,2.306,2.306,0,0,1,2.417-.292c.938.4,1.583,1.995,2.023,4.216a47.723,47.723,0,0,0,8.438,0c.439-2.221,1.085-3.816,2.022-4.216a2.306,2.306,0,0,1,2.417.292,1.835,1.835,0,0,1,.671,1.338,2.1,2.1,0,0,1-.711,1.581,7.058,7.058,0,0,1-3.992,1.538c-1.279,7.355-.425,21.592-.422,21.645l-.585.032c0-.053-.838-13.964.488-21.615a48.794,48.794,0,0,1-8.216,0c1.327,7.651.491,21.562.488,21.615Z",
    transform: "translate(-2153.977 -104.81)",
    fill: "#0a213d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139272",
    "data-name": "Path 139272",
    d: "M195.921,987.6l2.509,12.692-12.5,3.478c-8.62-7.91-16.662-16.455-21.555-28.451.006-1.193.53-1.732,1.511-1.7-.635-1.738.007-2.679,1.156-2.3-.2-1.973.665-2.121,1.49-1.736.038-.861.486-1.292,1.029-1.21l1.028.75a35.156,35.156,0,0,0,7.4,7.3c1.665,1.442,2.958,1.312,2.439-.125Z",
    transform: "translate(-139.916 -824.262)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139273",
    "data-name": "Path 139273",
    d: "M364.968,1095.937l-6.288,16.812L322.429,1089.4c-3.215-2.071-5.376-2.6-8.836-.062l-10.539,15.486c-.9,3.537-.572,6.426,1.254,8.52l45.027,43.428c7.527,7,21.212,8.087,27.247-2.644l12.177-48.431Z",
    transform: "translate(-257.544 -925.778)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139274",
    "data-name": "Path 139274",
    d: "M798.2,854.3l11.311,80.733H714.661l10.823-77.63L708.3,852.9l11.135-35.035c3.107-8.386,10.523-17.629,20.047-18.423l52.8-4.4c15.207.443,29,5.431,33.614,25.064l6.49,27.551Z",
    transform: "translate(-602.896 -676.727)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139275",
    "data-name": "Path 139275",
    d: "M1064.13,599.615l2.461,29.5,4.968-.414c-7.481,15.842-30.083,16.938-35.154,2.932l4.095-2.994-1.427-14.844Z",
    transform: "translate(-882.174 -510.384)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139276",
    "data-name": "Path 139276",
    d: "M891.566,306.051c-14.057-15.525-3.858-33.207,19.318-27.91l26.225,7.88c6.026,2.221,8.357,6.826,5.44,14.824l-2.635,9.356-22.549,18.991-25.8-23.141",
    transform: "translate(-753.428 -235.934)",
    fill: "#003336",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139277",
    "data-name": "Path 139277",
    d: "M930.7,413.558q-1.3-11.794-2.6-23.588c-.347-7.776,2.325-13.22,10.911-14.093,10.3.262,24.779-1.732,23.954,4.539q.7,7.318,1.4,14.635c.314,2.645,2.72,3.15,4.8,1.372,8.356-8.537,21.231,6.392,2.748,15.331-8.506,18.169-35.066,18.985-41.213,1.8",
    transform: "translate(-789.96 -319.853)",
    fill: "#ff9e8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139278",
    "data-name": "Path 139278",
    d: "M1070.726,690.936s-3,11.889-13.733,13.7l-1.016-10.564.215-.121a25.05,25.05,0,0,0,14.535-3.019",
    transform: "translate(-898.833 -588.115)",
    fill: "#003336",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139279",
    "data-name": "Path 139279",
    d: "M1237.531,1143.177l9.515,38.5-17.528,41.749h34.674l19.008-24.288c4.565-5.544,6.058-12.269,3.887-20.4l-11.048-42.69-26.232-2.195Z",
    transform: "translate(-1046.55 -965.121)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139280",
    "data-name": "Path 139280",
    d: "M1006.521,520.756a.383.383,0,1,1,.687.339l-4.99,10.1-.013.024h0a.962.962,0,0,0-.193.522c0,.021.057.04.16.056h2.25a.384.384,0,0,1,0,.768h-2.272l-.052,0a.863.863,0,0,1-.832-.655,1.55,1.55,0,0,1,.276-1.075Zm4.159,13.656a.383.383,0,0,1,.612.459c-.006.008-1.943,2.664-4.037,2.664a.384.384,0,1,1,0-.768c1.7,0,3.42-2.348,3.424-2.354",
    transform: "translate(-852.248 -443.079)",
    fill: "#003336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139281",
    "data-name": "Path 139281",
    d: "M974.761,470.26a.383.383,0,1,1-.159.75c-.012,0-4.224-.923-6.753.18a.383.383,0,0,1-.306-.7c2.759-1.2,7.2-.23,7.217-.228m-16.649,0a.383.383,0,1,1-.159.75c-.012,0-4.224-.923-6.753.18a.383.383,0,1,1-.306-.7c2.759-1.2,7.2-.23,7.217-.228",
    transform: "translate(-809.193 -399.96)",
    fill: "#003336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139282",
    "data-name": "Path 139282",
    d: "M962.828,520.943a1.39,1.39,0,1,0,1.39,1.39,1.39,1.39,0,0,0-1.39-1.39",
    transform: "translate(-818.363 -443.42)",
    fill: "#003336",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139283",
    "data-name": "Path 139283",
    d: "M1074.708,520.943a1.39,1.39,0,1,0,1.39,1.39,1.39,1.39,0,0,0-1.39-1.39",
    transform: "translate(-913.593 -443.42)",
    fill: "#003336",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139284",
    "data-name": "Path 139284",
    d: "M915.35,476.933a7.64,7.64,0,1,0,2.237,5.4,7.616,7.616,0,0,0-2.237-5.4m-5.4-2.981a8.384,8.384,0,1,1-5.928,2.456,8.355,8.355,0,0,1,5.928-2.456",
    transform: "translate(-767.4 -403.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139285",
    "data-name": "Path 139285",
    d: "M1053.223,476.933a7.64,7.64,0,1,0,2.237,5.4,7.615,7.615,0,0,0-2.237-5.4m-5.4-2.981a8.384,8.384,0,1,1-5.928,2.456,8.356,8.356,0,0,1,5.928-2.456",
    transform: "translate(-884.756 -403.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18737",
    "data-name": "Rectangle 18737",
    width: 4.495,
    height: 0.744,
    transform: "translate(150.559 78.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139286",
    "data-name": "Path 139286",
    d: "M1148.013,508.763l9.429-3.567.262.695-9.429,3.567Z",
    transform: "translate(-977.173 -430.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139287",
    "data-name": "Path 139287",
    d: "M246.35,551.108c-2.239-4.914-5.3-7.954-8.651-7.954s-6.412,3.04-8.651,7.954c-2.278,5-3.688,11.922-3.688,19.576s1.41,14.574,3.688,19.576c2.239,4.914,5.3,7.954,8.651,7.954s6.412-3.04,8.651-7.954c2.278-5,3.688-11.923,3.688-19.576s-1.41-14.574-3.688-19.576m-8.651-8.7c3.668,0,6.964,3.207,9.325,8.391,2.321,5.1,3.758,12.127,3.758,19.884s-1.436,14.788-3.758,19.884c-2.362,5.184-5.657,8.39-9.325,8.39s-6.964-3.207-9.325-8.39c-2.322-5.1-3.758-12.128-3.758-19.884s1.436-14.787,3.758-19.884c2.362-5.184,5.657-8.391,9.325-8.391",
    transform: "translate(-191.19 -461.691)",
    fill: "#459ed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139288",
    "data-name": "Path 139288",
    d: "M178.546,586.4c-5.061-1.886-9.375-1.868-11.741.5s-2.377,6.687-.479,11.744c1.929,5.142,5.826,11.02,11.232,16.419l.02.019h0c5.416,5.4,11.311,9.295,16.463,11.216,5.061,1.887,9.375,1.867,11.741-.5s2.377-6.687.479-11.744c-1.929-5.141-5.826-11.02-11.232-16.419l-.02-.019h0c-5.416-5.4-11.312-9.295-16.463-11.216m-12.267-.019c2.591-2.6,7.189-2.665,12.525-.675,5.246,1.956,11.237,5.906,16.728,11.385h0l.02.021c5.481,5.474,9.436,11.448,11.4,16.684,2,5.332,1.943,9.929-.648,12.526s-7.189,2.665-12.525.676c-5.246-1.956-11.237-5.906-16.728-11.385h0l-.02-.022c-5.481-5.474-9.436-11.448-11.4-16.684-2-5.332-1.943-9.929.648-12.526",
    transform: "translate(-139.784 -497.355)",
    fill: "#459ed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139289",
    "data-name": "Path 139289",
    d: "M123.275,657.637h0c.007,3.35,3.054,6.4,7.973,8.632,5.01,2.269,11.935,3.665,19.585,3.649h0c7.65-.016,14.568-1.441,19.567-3.732,4.91-2.249,7.943-5.317,7.936-8.668h0c-.007-3.35-3.054-6.4-7.973-8.632-5.01-2.269-11.935-3.665-19.585-3.649v0h0v0c-7.65.017-14.568,1.441-19.567,3.732-4.91,2.249-7.943,5.317-7.936,8.668m-.743,0h0c-.007-3.668,3.191-6.97,8.37-9.343,5.089-2.331,12.116-3.782,19.875-3.8h0c7.759-.016,14.793,1.4,19.891,3.713,5.188,2.35,8.4,5.639,8.409,9.309h0c.008,3.668-3.191,6.97-8.37,9.342-5.089,2.332-12.117,3.782-19.875,3.8h0c-7.759.016-14.793-1.4-19.891-3.713-5.188-2.35-8.4-5.639-8.41-9.309Z",
    transform: "translate(-104.298 -548.585)",
    fill: "#459ed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139290",
    "data-name": "Path 139290",
    d: "M166.7,613.786c-1.876,5.065-1.848,9.38.529,11.741s6.691,2.362,11.743.454c5.138-1.941,11.008-5.849,16.4-11.266l.019-.021h0c5.392-5.426,9.269-11.329,11.179-16.486,1.877-5.065,1.848-9.38-.528-11.741s-6.691-2.362-11.744-.453c-5.138,1.941-11.008,5.849-16.4,11.266l-.019.021h0c-5.391,5.426-9.269,11.329-11.179,16.486m.005,12.267c-2.6-2.586-2.681-7.183-.7-12.523,1.945-5.249,5.882-11.249,11.351-16.753h0l.021-.02c5.463-5.493,11.428-9.461,16.659-11.436,5.328-2.013,9.925-1.964,12.528.622s2.681,7.183.7,12.523c-1.945,5.25-5.882,11.249-11.351,16.754h0l-.021.02c-5.463,5.493-11.428,9.461-16.659,11.436-5.328,2.012-9.925,1.964-12.528-.622",
    transform: "translate(-140.129 -497.005)",
    fill: "#459ed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139291",
    "data-name": "Path 139291",
    d: "M299.677,717.307a2.248,2.248,0,1,1-2.248,2.248,2.247,2.247,0,0,1,2.248-2.248",
    transform: "translate(-253.168 -610.562)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139292",
    "data-name": "Path 139292",
    d: "M357,578.3a2.248,2.248,0,1,1-2.248,2.248A2.248,2.248,0,0,1,357,578.3",
    transform: "translate(-301.958 -492.238)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139293",
    "data-name": "Path 139293",
    d: "M213.731,680.354a2.594,2.594,0,1,1-2.594,2.594,2.595,2.595,0,0,1,2.594-2.594",
    transform: "translate(-179.717 -579.108)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139294",
    "data-name": "Path 139294",
    d: "M430.416,847.418a2.594,2.594,0,1,1-2.594,2.594,2.594,2.594,0,0,1,2.594-2.594",
    transform: "translate(-364.157 -721.311)",
    fill: "#ff6e63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139295",
    "data-name": "Path 139295",
    d: "M66.944,317.784a2.543,2.543,0,0,0-3.6,3.595h0a2.542,2.542,0,0,0,3.6-3.6m-52.9,175.109a.441.441,0,1,1-.882,0v-4.239a.441.441,0,1,1,.882,0Zm6.185-2.927a.441.441,0,1,1-.624.623l-3-3a.441.441,0,0,1,.624-.624Zm-7.067-14.931a.441.441,0,1,1,.882,0v4.238a.441.441,0,1,1-.882,0Zm-6.185,2.927a.441.441,0,0,1,.624-.624l3,3a.441.441,0,0,1-.624.624Zm-2.3,6.444a.441.441,0,0,1,0-.883H8.913a.441.441,0,1,1,0,.883Zm17.859-.883a.441.441,0,1,1,0,.883H18.294a.441.441,0,1,1,0-.883Zm-2.927-6.184a.441.441,0,0,1,.624.624l-3,3a.441.441,0,0,1-.624-.624Zm-12,13.251a.441.441,0,1,1-.624-.623l3-3a.441.441,0,1,1,.624.624Zm42.105,39.276a.441.441,0,0,1,.624-.623l3.136,3.136,3.136-3.136a.441.441,0,1,1,.624.623L54.091,533l3.136,3.136a.441.441,0,1,1-.624.624l-3.136-3.136-3.136,3.136a.441.441,0,0,1-.624-.624L52.843,533ZM.442,551.72a.441.441,0,1,1,0-.883h8a.441.441,0,0,1,0,.883ZM105.525,352.729a.441.441,0,0,1,.624-.624l1.3,1.3,1.3-1.3a.441.441,0,0,1,.624.624l-1.3,1.3,1.3,1.3a.441.441,0,0,1-.624.624l-1.3-1.3-1.3,1.3a.441.441,0,0,1-.624-.624l1.3-1.3ZM35.03,436.471a.441.441,0,1,1,0-.883H40.2a.441.441,0,0,1,0,.883Zm-11.1,0a.441.441,0,0,1,0-.883h7.31a.441.441,0,0,1,0,.883Zm439.9,59.456a.441.441,0,1,1,.624-.624l3.136,3.136,3.136-3.136a.441.441,0,1,1,.624.624l-3.136,3.136,3.136,3.136a.441.441,0,1,1-.624.623l-3.136-3.136-3.136,3.136a.441.441,0,1,1-.624-.623l3.136-3.136ZM382.307,349.1a.442.442,0,0,1-.883,0v-4.238a.442.442,0,1,1,.883,0Zm6.184-2.927a.441.441,0,0,1-.623.624l-3-3a.441.441,0,0,1,.624-.624Zm-7.067-14.932a.442.442,0,0,1,.883,0v4.238a.442.442,0,0,1-.883,0Zm-6.185,2.927a.441.441,0,0,1,.624-.624l3,3a.441.441,0,0,1-.623.624Zm-2.3,6.443a.441.441,0,0,1,0-.883h4.239a.441.441,0,0,1,0,.883Zm17.858-.883a.441.441,0,1,1,0,.883h-4.239a.441.441,0,1,1,0-.883Zm-2.927-6.185a.441.441,0,1,1,.623.624l-3,3a.441.441,0,0,1-.624-.624Zm-12,13.252a.441.441,0,0,1-.624-.624l3-3a.441.441,0,0,1,.623.624Zm25.455,40.668a.441.441,0,0,1,.624-.624l3.136,3.136,3.136-3.136a.441.441,0,1,1,.624.624L405.7,390.6l3.136,3.136a.441.441,0,1,1-.624.624l-3.136-3.136-3.136,3.136a.441.441,0,0,1-.624-.624l3.136-3.136Zm19.575-65.539a.441.441,0,1,1,0-.883h8a.441.441,0,1,1,0,.883Zm-27.693,120a2.542,2.542,0,0,0-3.6,3.595l0,0a2.542,2.542,0,0,0,3.594-3.6m-1.8-1.626a3.412,3.412,0,0,1,2.419,1l0,0a3.422,3.422,0,1,1-4.84,4.84h0a3.423,3.423,0,0,1,2.421-5.843m36.167,117.8a.441.441,0,1,1,0-.883h24.522a.441.441,0,0,1,0,.883Zm-16.713.1a.441.441,0,1,1,0-.883h8a.441.441,0,0,1,0,.883ZM337.82,396.665a.441.441,0,0,1,.624-.624l1.3,1.3,1.3-1.3a.441.441,0,0,1,.624.624l-1.3,1.3,1.3,1.3a.441.441,0,0,1-.624.624l-1.3-1.3-1.3,1.3a.441.441,0,0,1-.624-.624l1.3-1.3ZM65.146,316.158a3.411,3.411,0,0,1,2.419,1h0a3.422,3.422,0,1,1-4.84,4.84h0a3.423,3.423,0,0,1,2.421-5.843",
    transform: "translate(0 -269.109)",
    fill: "#424773"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.4e0387c2879322e0020ab5105a63a819.svg";
export { ForwardRef as ReactComponent };